import { Card, Skeleton, } from "@mui/material";
import { isMobile, isDesktop, isIpad } from '../../../global/ScreenSizeHelper'
import { CLOUD_KITCHEN_SUB_TEXT } from "../../../global/constants";



const widthMobileCont = isMobile ? 150 : 230
const widthCont = isIpad ? 200 : widthMobileCont


export const CloudKitchenSkeleton = () => {

    const widthContainer = isIpad ? 'auto' : '800px';
    const widthIpadMobile = isIpad ? '180px' : '240px';


    if (isMobile) {
        return (
            <div style={{
                minWidth: '260px', width: 'auto', display: 'flex', border: '1px solid lightgrey',
                flexDirection: 'column', margin: '5px 15px 100px', padding: '10px', borderRadius: '5px', overflow: 'hidden'
            }}>
                <div style={{ fontSize: '16px', fontWeight: '700', color: 'grey', margin: '10px 0px 5px 15px' }}> Cloud Kitchen</div>
                <div style={{ fontSize: '12px', fontWeight: '400', color: 'grey', margin: '0px 10px 5px 15px', marginLeft: '14px' }}> {CLOUD_KITCHEN_SUB_TEXT}</div>
                <div style={{
                    width: 'auto',
                    height: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    margin: '5px 15px'
                }}>
                    <Skeleton variant="rounded" height={220} />
                    <Skeleton variant="text" sx={{ height: '25px', width: '140px' }} animation="wave" />
                    <Skeleton variant="text" sx={{ height: '18px', width: '240px' }} animation="wave" />

                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: '15px'
                }}>


                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Skeleton variant="rounded" sx={{ height: '120px', width: '100%', marginLeft: '15px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '120px', marginLeft: '15px', marginTop: '10px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '140px', marginLeft: '15px', marginTop: '3px' }} animation="wave" />

                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Skeleton variant="rounded" sx={{ height: '120px', width: '100%', marginLeft: '20px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '120px', marginLeft: '15px', marginTop: '10px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '140px', marginLeft: '15px', marginTop: '3px' }} animation="wave" />

                    </div>
                </div>



            </div>


        )
    }



    return (
        <div style={{
            minWidth: '260px', width: widthContainer, display: 'flex', border: '1px solid lightgrey',
            flexDirection: 'column', margin: '15px 5px', padding: '15px', borderRadius: '5px', overflow: 'hidden'
        }}>
            <div style={{ fontSize: '16px', fontWeight: '700', color: 'grey', margin: '10px 0px 5px 15px' }}> Cloud Kitchen</div>
            <div style={{ fontSize: '14px', fontWeight: '500', color: 'grey', margin: '0px 10px 5px 15px', marginLeft: '14px' }}> {CLOUD_KITCHEN_SUB_TEXT}</div>

            <div style={{
                display: 'flex',
                flexDirection: 'row', overflow: 'hidden'
            }}>
                <div style={{
                    minWidth: 100, height: 'auto', width: widthIpadMobile, display: 'flex',
                    flexDirection: 'column', margin: '0px', padding: '15px'
                }}>
                    <Skeleton variant="rounded" height={220} />
                    <Skeleton variant="text" sx={{ height: '25px', width: '100px' }} animation="wave" />
                    <Skeleton variant="text" sx={{ height: '18px', width: '200px' }} animation="wave" />

                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: '15px'
                }}>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Skeleton variant="rounded" sx={{ height: '120px', width: isIpad ? '135px' : '160px', marginLeft: '15px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '120px', marginLeft: '15px', marginTop: '10px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '140px', marginLeft: '15px', marginTop: '3px' }} animation="wave" />

                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Skeleton variant="rounded" sx={{ height: '120px', width: isIpad ? '135px' : '160px', marginLeft: '15px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '120px', marginLeft: '15px', marginTop: '10px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '140px', marginLeft: '15px', marginTop: '3px' }} animation="wave" />

                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Skeleton variant="rounded" sx={{ height: '120px', width: isIpad ? '135px' : '160px', marginLeft: '15px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '120px', marginLeft: '15px', marginTop: '10px' }} animation="wave" />
                        <Skeleton variant="text" sx={{ height: '18px', width: '140px', marginLeft: '15px', marginTop: '3px' }} animation="wave" />

                    </div>

                </div>
            </div>
        </div>



    )
}

export const HomeChefSkeleton = () => {
    return <Card sx={{
        minWidth: 100, height: 'auto', width: widthCont, display: 'flex',
        flexDirection: 'column', margin: isMobile ? '5px 15px 5px' : '5px 10px', padding: '15px'
    }}>
        <Skeleton variant="rounded" height={150} />
        <Skeleton variant="text" sx={{ height: '25px', width: '100px' }} animation="wave" />
        <Skeleton variant="text" sx={{ height: '18px', width: isMobile ? '130px' : '200px' }} animation="wave" />
        <div style={{ display: 'flex', marginTop: '10px' }}>
            <Skeleton variant="rounded" sx={{ height: '70px', width: '50px' }} animation="wave" />
            <Skeleton variant="rounded" sx={{ height: '70px', width: '50px', marginLeft: '10px' }} animation="wave" />
            <Skeleton variant="rounded" sx={{ height: '70px', width: '50px', marginLeft: '10px' }} animation="wave" />

        </div>
    </Card>
}


export const RestaurantSkeleton = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            margin: isMobile ? '10px' : '10px'
        }}>
            <Skeleton variant="rounded" width={isMobile ? 60 : 100} height={isMobile ? 70 : 100} />

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
                <Skeleton variant="text" sx={{ height: '20px', width: isMobile ? '180px' : '280px' }} animation="wave" />
                <Skeleton variant="text" sx={{ height: '20px', width: isMobile ? '240px' : '280px' }} animation="wave" />
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Skeleton variant="rounded" sx={{ height: '20px', width: isMobile ? '40px' : '100px', marginTop: '5px' }} />
                    <Skeleton variant="rounded" sx={{ height: '20px', width: isMobile ? '40px' : '100px', marginTop: '5px', marginLeft: '10px' }} />
                    <Skeleton variant="rounded" sx={{ height: '20px', width: isMobile ? '40px' : '100px', marginTop: '5px', marginLeft: '10px' }} />

                </div>
                {!isMobile && <Skeleton variant="text" sx={{ height: '15px', width: isMobile ? '40px' : '200px', marginTop: '10px' }} animation="wave" />}

            </div>
        </div>)

}

export const TabSkeleton = () => {

    const height = isMobile ? '10px' : '15px';
    const marginLeft = isMobile ? '10px' : null;

    return (

        <div style={{ display: 'flex', marginTop: '10px', marginLeft: marginLeft }}>
            <Skeleton variant="rounded" sx={{ fontSize: '2rem', height: height, width: '30px', margin: '5px', border: '2px solid #D4D4D4' }} />
            <Skeleton variant="rounded" sx={{ fontSize: '2rem', height: height, width: '50px', margin: '5px', border: '2px solid #D4D4D4' }} />
            <Skeleton variant="rounded" sx={{ fontSize: '2rem', height: height, width: '60px', margin: '5px', border: '2px solid #D4D4D4' }} />
            <Skeleton variant="rounded" sx={{ fontSize: '2rem', height: height, width: '60px', margin: '5px', border: '2px solid #D4D4D4' }} />
            <Skeleton variant="rounded" sx={{ fontSize: '2rem', height: height, width: '50px', margin: '5px', border: '2px solid #D4D4D4' }} />
        </div>
    )

}